import React from 'react';
import { Link } from 'react-router-dom';

export const HomeScreen = (): React.ReactElement => {
	return (
		<>
			<Link to="logout">Logout</Link>
		</>
	);
};
